import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const getAllAcademicYear = async (context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/year/all`, {
    headers: setHeaders(context),
  });
  return response.data;
};

export const createUE = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + "/api/ue/create",
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllUEByPeriod = async (idClass, idPeriod, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/ue/all/${idClass}/${idPeriod}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllUEByClass = async (idClass, context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/ue/all/${idClass}`, {
    headers: setHeaders(context),
  });
  return response.data;
};

export const getUEById = async (id, context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/ue/getUE/${id}`, {
    headers: setHeaders(context),
  });
  return response.data;
};

export const updateUE = async (payload, id, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/ue/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteUE = async (id, context) => {
  const response = await axios.delete(apiPaths.baseUrl + `/api/ue/${id}`, {
    headers: setHeaders(context),
  });
  return response.data;
};

export const createSubjectUE = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + "/api/subjectUE/create",
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getSubjectUEById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/subjectUE/getSubjectUE/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateSubjectUE = async (payload, id, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/subjectUE/update/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteSubjectUE = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/subjectUE/delete/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const importUE = async (payload, idEvaluationPeriod, idClass) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/importUE/${idEvaluationPeriod}/${idClass}`,
    payload,
    {
      headers: { ...setHeaders(), "Content-Type": "multipart/form-data" },
    },
  );
  return response.data;
};

export const importECU = async (
  payload,
  idYear,
  idEvaluationPeriod,
  idClass,
) => {
  const response = await axios.post(
    apiPaths.baseUrl +
      `/api/importSubjectUE/${idYear}/${idEvaluationPeriod}/${idClass}`,
    payload,
    {
      headers: { ...setHeaders(), "Content-Type": "multipart/form-data" },
    },
  );
  return response.data;
};
